/* eslint-disable */
import girl1 from '../assets/svg/testimonials/girl1.svg'
import girl2 from '../assets/svg/testimonials/girl2.svg'
import girl3 from '../assets/svg/testimonials/girl3.svg'
import boy1 from '../assets/svg/testimonials/boy1.svg'
import boy2 from '../assets/svg/testimonials/boy2.svg'
import boy3 from '../assets/svg/testimonials/boy3.svg'



export const testimonialsData = [
    {
        id: 1,
        name: 'Saruque Ahamed Mollick',
        title: 'Managing Director at CodeSpeedy Technology Private Limited',
        text: "Rakesh Ganesula has completed his internship as a C++ Developer at our organization. As I assisted him personally, I can surely say that he is a good fit for the IT industry. He will be beneficial for this industry.",
        image: boy2
    },
    {
        id: 2,
        name: 'Neeraj Dusa',
        title: 'Crio Software Developer',
        text: "I had the pleasure of working with Rakesh on a project for Web Development using React. He was highly motivated, took the lead in one of the tasks and did a great job. Rakesh made a great contribution to the project.",
        image: boy3
    },
    {
        id: 3,
        name: 'Harish Mullagura',
        title: 'Commvault Software Developer',
        text: "Rakesh is a great team player, with profound knowledge in the field of Web and Software Development. His contributions throughout the project on Django were pivotal and, beneficial for our team.",
        image: boy1
    }
    // {
    //     id: 4,
    //     name: 'Joey Tribbiani',
    //     title: 'Actor',
    //     text: "Making my portfolio with this helped me get my role as 'Dr. Drake Ramoray' in 'Days Of Our Lives'. You guys are the best !",
    //     image: boy1
    // },
    // {
    //     id: 5,
    //     name: 'Rachel Green',
    //     title: 'Sales Executive',
    //     text: 'Ralph Lauren was one of the best things that ever happened to me. My portfolio made that dream happen. I owe you guys.',
    //     image: girl3
    // },
    // {
    //     id: 6,
    //     name: 'Ross Geller',
    //     title: 'Paleontologist',
    //     text: "Be it 'Rocks' or 'Bones', you need a website to display it. This is it. Great work guys !",
    //     image: boy3
    // }
]

